import { useState } from "react";
import { Button, ButtonProps } from "antd";
import { useScrollToTop } from "../../hooks/useScrollToTop";

export interface ExpandCollapseAllButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
  expanded: boolean;
  onToggle: () => void;
}

// Every "Expand All"/"Collapse All" control in the app should scroll back to
// the top of the page when clicked, since expanding/collapsing every panel
// shifts everything below the button. Centralised here so that behavior (and
// the `expand-collapse-all-btn` class, which keeps this button visible/
// clickable in view-mode — see index.css) stays consistent everywhere.
export default function ExpandCollapseAllButton({ expanded, onToggle, className, size = 'small', ...rest }: ExpandCollapseAllButtonProps) {
  const [scrollNonce, setScrollNonce] = useState(0);
  useScrollToTop({ behavior: 'smooth', delay: 100, trigger: scrollNonce });

  return (
    <Button
      size={size}
      className={className ? `expand-collapse-all-btn ${className}` : 'expand-collapse-all-btn'}
      onClick={() => {
        onToggle();
        setScrollNonce((n) => n + 1);
      }}
      {...rest}
    >
      {expanded ? 'Collapse All' : 'Expand All'}
    </Button>
  );
}
